module.exports = __webpack_public_path__ + "7dfb58562666c155258ea5362408443d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/hans-peter_kohler_landscape.jpg
// module id = 342
// module chunks = 0